<template>
  <div class="app-content">
    <el-form
        :inline="true"
        :model="dataForm"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="工厂：">
        <el-input v-model="dataForm.code" placeholder="" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data(){
    return {
      dataForm:{
        factoryId:''
      }

    }
  },
  methods:{

  }
}
</script>

<style lang="scss" scoped>
.app-content{
}
</style>
